/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDCornerLeftDownIcon16Light } from './ArrowDCornerLeftDownIcon16Light';
import { ArrowDCornerLeftDownIcon16Regular } from './ArrowDCornerLeftDownIcon16Regular';
import { ArrowDCornerLeftDownIcon16Solid } from './ArrowDCornerLeftDownIcon16Solid';
import { ArrowDCornerLeftDownIcon20Light } from './ArrowDCornerLeftDownIcon20Light';
import { ArrowDCornerLeftDownIcon20Regular } from './ArrowDCornerLeftDownIcon20Regular';
import { ArrowDCornerLeftDownIcon20Solid } from './ArrowDCornerLeftDownIcon20Solid';
import { ArrowDCornerLeftDownIcon24Regular } from './ArrowDCornerLeftDownIcon24Regular';
import { ArrowDCornerLeftDownIcon24Solid } from './ArrowDCornerLeftDownIcon24Solid';
import { ArrowDCornerLeftDownIcon32Regular } from './ArrowDCornerLeftDownIcon32Regular';
import { ArrowDCornerLeftDownIcon64Regular } from './ArrowDCornerLeftDownIcon64Regular';
var sizes = {
    16: {
        light: ArrowDCornerLeftDownIcon16Light,
        regular: ArrowDCornerLeftDownIcon16Regular,
        solid: ArrowDCornerLeftDownIcon16Solid,
    },
    20: {
        light: ArrowDCornerLeftDownIcon20Light,
        regular: ArrowDCornerLeftDownIcon20Regular,
        solid: ArrowDCornerLeftDownIcon20Solid,
    },
    24: {
        regular: ArrowDCornerLeftDownIcon24Regular,
        solid: ArrowDCornerLeftDownIcon24Solid,
    },
    32: {
        regular: ArrowDCornerLeftDownIcon32Regular,
    },
    64: {
        regular: ArrowDCornerLeftDownIcon64Regular,
    },
};
export var ArrowDCornerLeftDownIcon = forwardRef('ArrowDCornerLeftDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
